// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"2176":"63edc82b","5577":"f23b0878"}[chunkId] || chunkId) + "." + {"2176":"128dbcdcc87817b3","2858":"22473ebb4a424a8c","5577":"97471755f5c08cab","6440":"b1cdeca40cfae355","9655":"9e2692bbe0638310","9774":"9896030ceec6c6fc"}[chunkId] + ".js";
};